import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  languageToggleButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: theme.fontSizes.cta,
    height: theme.dimensions.nav.languageToggleSquare,
    width: theme.dimensions.nav.languageToggleSquare,
    boxSizing: 'border-box',
    backgroundColor: theme.palette.purple,
    border: `2px  solid  ${theme.palette.yellow}`,
    color: theme.palette.white,
    fontFamily: 'Veneer, Arial',
    textDecoration: 'none',
    transition: 'all 0.2s ease-in-out',
    position: 'relative',
    margin: '1rem',
    minHeight: theme.dimensions.nav.languageToggleSquare,
    '&:hover':{
      border: `2px  solid  ${theme.palette.white}`,
      color: theme.palette.yellow,
    },
    '&:focus':{
      backgroundColor: theme.palette.gridPurple,
      border: `2px  solid  ${theme.palette.white}`,
      color: theme.palette.yellow,
      outline: "none"
    },
  },
  languageToggleLabel: {
    position: 'absolute',
    transition: 'all 0.2s ease-in-out',
    transform: 'scale(1.5)',
    opacity: 0,
    pointerEvents: 'none',
    whiteSpace: "nowrap",
    '&.visible':{
      transform: 'scale(1)',
      opacity: 1,
    },
    '&.hover':{
      transform: 'scale(1) translateY(0) !important',
      opacity: '1 !important',
    },
    '&.out':{
      transform: 'scale(1) translateY(-10px) !important',
      opacity: '0 !important',
    },
    '&.focus':{
      transform: 'scale(1) translateY(0) !important',
      opacity: '1 !important',
    },
    '&.blur':{
      transform: 'scale(1) translateY(-10px) !important',
      opacity: '0 !important',
    }
  },
  languageToggleES: {
    color: theme.palette.white
  },
  languageToggleEN: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: theme.fontSizes.cta,
    height: theme.languageButtonSquare,
    width: theme.languageButtonSquare,
    backgroundColor: theme.palette.yellow
  }
}));
